import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type { AppNotification, NotificationsListParams } from '../types';

const { NOTIFICATIONS } = API_ENDPOINTS;

export const notificationsApi = {
  getAll: (params?: NotificationsListParams) =>
    apiClient.getPaginated<AppNotification>(NOTIFICATIONS.LIST, params),

  getUnreadCount: () =>
    apiClient.get<{ count: number }>(NOTIFICATIONS.UNREAD_COUNT),

  markAsRead: (id: string) => apiClient.patch(NOTIFICATIONS.MARK_AS_READ(id)),

  markAllAsRead: () => apiClient.post(NOTIFICATIONS.MARK_ALL_READ)
};
